import { saPushEvent } from "@spot-fe/utils";

export const evt = 'SpotDepositToEarnPageClick';

export const ongoingProjectClick = () => {
  saPushEvent(evt, {
    page_name: 'DepositToEarnHomePage',
    page_area: 'Ongoing',
    button_name: 'JoinNow',
  });
}

export const completedProjectClick = () => {
  saPushEvent(evt, {
    page_name: 'DepositToEarnHomePage',
    page_area: 'Completed',
    button_name: 'MoreDetail',
  });
}

export const faqClick = () => {
  saPushEvent(evt, {
    page_name: 'DepositToEarnHomePage',
    page_area: 'FAQ',
    button_name: 'FAQ',
  });
}

// todo
export const taskClick = (name: string) => {
  // const name = ''
  saPushEvent(evt, {
    page_name: 'DepositToEarnDetailsPage',
    page_area: 'RewardsCard',
    button_name: name,
  });
}

export const advClick = (pos: number) => {
  const list = ['AdvPosition1', 'AdvPosition2', 'AdvPosition3', 'AdvPosition4', 'AdvPosition5']
  saPushEvent(evt, {
    page_name: 'DepositToEarnDetailsPage',
    page_area: 'Advertisement',
    button_name: list[pos],
  });
}

export const depositClick = (pos: number) => {
  const list = ['BuyNow', 'DepositUSDT', 'DepositNewToken']
  saPushEvent(evt, {
    page_name: 'DepositToEarnDetailsPage',
    page_area: 'DepositDialog',
    button_name: list[pos],
  });
}

export const waitClick = () => {
  saPushEvent(evt, {
    page_name: 'DepositToEarnDetailsPage',
    page_area: 'DepositDialog',
    button_name: 'OK',
  });
}
